<template>
  <div v-loading="loadingx">
    <el-form-item :label="title">
      <el-input style="width:100%;margin-top:5px;" v-model="address_" @change="changeAddres"
        placeholder="请输入位置后点击右侧图标确定坐标"><i v-if="address_ != ''" slot="suffix" class="dnnfont iconrenyuandingwei"
          style="cursor:pointer;color:#666666;" @click="openMap"></i></el-input>
    </el-form-item>
    <el-dialog :visible.sync="innerVisible" append-to-body :fullscreen="true" @opened="initMap">
      <span slot="title">
        <el-select v-model="posValue" filterable remote :remote-method="remoteMethod" :loading="loading"
          placeholder="请输入关键词" @change="posChange" style="width:500px;">
          <el-option v-for="(item, index) in options" :key="index + ''" :label="item.name + '(' + item.address + ')'"
            :value="item.location.toString()"></el-option>
        </el-select>
      </span>
      <div id="map" class="map" v-loading="loadings"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="innerVisible = false">取 消</el-button>
        <el-button type="primary" @click="positions(position)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { API__Position } from '@/api/index.js'
import {
  sendThis,
  Load_Map,
  addDrawPoint,
  addPoint,
  rewritePos,
  toLonLat_,
} from '@/views/administrator/console/assembly/openlayers/iMap.js'
export default {
  props: {
    selected: {
      //地址选择的默认选项
      type: Object,
      default: function () {
        return { province: '320000', city: '320100', area: '320115', town: '320115010' }
      },
    },
    address: {
      //地址文字地址
      type: String,
      default: '',
    },
    position_: {
      type: Array,
      default: function () {
        return [118.846567, 31.958527]
      },
    },
    title: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      position: [118.846567, 31.958527],
      innerVisible: false,
      selected_: this.selected,
      address_: this.address,
      posValue: '',
      loading: false,
      options: [],
      selecedddd: '',
      index_: 0,
      shangxian: 1,
      loadingx: false,
      loadings: false,
      token: '',
      checkCode: '',
      id: '',
      ischange: true,
    }
  },
  mounted() {
    if (document.cookie.length > 0) {
      var arr = document.cookie.split('; ') //这里显示的格式需要切割一下自己可输出看下
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split('=') //再次切割
        //判断查找相对应的值
        if (arr2[0] == 'dnnyptadmin_token') {
          this.token = arr2[1] //保存到保存数据的地方
        } else if (arr2[0] == 'dnnyptadmin_checkCode') {
          this.checkCode = arr2[1]
        } else if (arr2[0] == 'dnnyptadmin_id') {
          this.id = arr2[1]
        }
      }
    }
  },
  methods: {
    openMap() {
      this.address_ = this.address_.split(' ').join('')
      this.innerVisible = true
    },
    initMap() {
      sendThis(this)   
      var param = {
        photography: false,
        popup: false,
        mappParma: {
          zoom: 12,
          mapCenter: this.position == '' ? [118.846567, 31.958527] : this.position,
        },
      }
      Load_Map(param)
      addDrawPoint()
      addPoint()
      this.posValue = ''

      this.initRemote(this.address_)
    },
    initRemote(query) {
      if (query != '') {
        let self = this
        self.loadings = true
        let params = {
          city: '全国',
          area: query,
          token: self.token,
          checkCode: self.checkCode,
        }
        API__Position.getPosition(params).then((res) => {
          self.loadings = false
          self.options = []
          if (res.data.data.length != 0) {
            res.data.data.forEach((element) => {
              self.options.push({
                address: element.address,
                name: element.name,
                location: [element.location.lng, element.location.lat],
              })
            })
            setTimeout(function () {
              // self.posValue = self.options[0].location
              self.posValue = self.options[0].location.toString()
              // if (self.ischange) {
                self.posChange()
              // }
            }, 100)
          }
        })
      }
    },
    positions(coordinate) { 
      this.position = coordinate||this.posValue
      let param = {
        pos: [toLonLat_(coordinate)[1], toLonLat_(coordinate)[0]],
        token: this.token,
        checkCode: this.checkCode,
      }
      API__Position.getaddressfromposition(param).then((res) => {
        this.$emit('backPram', {
          position: this.position,
          address: this.address_,
          selected: {
            province: { key: '320105', value: res.data.data.result.addressComponent.province },
            city: { key: '320105', value: res.data.data.result.addressComponent.city },
            area: { key: '320105', value: res.data.data.result.addressComponent.district },
          },
        })
        this.innerVisible = false
      })
    },
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        let params = {
          city: '全国',
          area: query,
          token: this.token,
          checkCode: this.checkCode,
        }
        API__Position.getPosition(params).then((res) => {
          this.loading = false
          this.options = []
          if (res.data.data.length != 0) {
            res.data.data.forEach((element) => {
              this.options.push({
                address: element.address,
                name: element.name,
                location: [element.location.lng, element.location.lat],
              })
            })
          }
        })
      }
    },
    posChange() {
      // console.log([Number(this.posValue.split(',')[0]),Number(this.posValue.split(',')[1])])
      // rewritePos(this.posValue.split(','))
      rewritePos([Number(this.posValue.split(',')[0]), Number(this.posValue.split(',')[1])])
    },
    changItem(param) {
      this.address_ = param
    },
    changePro(param) {
      this.shangxian = 2
      this.selected_ = param
    },
    changePos(pos) {
      let self = this
      this.ischange = false
      setTimeout(function () {
        self.position = pos
        // self.posChange();
      })
    },
    changeAddres() {
      this.$emit('update:address', this.address_)
      this.ischange = true
    },
  },
}
</script>

<style lang="scss" scoped>
.map {
  width: 100%;
  height: 750px;
}
</style>



// WEBPACK FOOTER //
// GisCommon.vue?813e4b76